import type { SlideDefinition } from "../../types";

export const bmwSlides: SlideDefinition[] = [
  // === OPENING ===
  {
    id: "title",
    component: "TitleSlide",
    props: {},
  },
  {
    id: "agenda",
    component: "AgendaSlide",
    props: {},
  },

  // === 01 INTRODUCTIONS ===
  {
    id: "section-intro",
    component: "SectionDividerSlide",
    props: { number: "01", title: "INTRODUCTIONS" },
  },
  {
    id: "team",
    component: "TeamSlide",
    props: {},
  },
  {
    id: "cars",
    component: "ImageGridSlide",
    props: {},
  },
  {
    id: "v-model",
    component: "VModelSlide",
    props: {},
  },
  {
    id: "what-we-do",
    component: "GanttSlide",
    props: {},
  },

  // === 02 DEMO ===
  {
    id: "section-demo",
    component: "SectionDividerSlide",
    props: { number: "02", title: "DEMO" },
  },
  {
    id: "demo-transition",
    component: "DemoTransitionSlide",
    props: {
      title: "Launching the Null Autos Platform",
      subtitle: "Live walkthrough of the development workflow",
      checklist: [
        "Platform Onboarding",
        "Templates & Snapshots",
        "Cloud Emulators",
        "Remote Workspaces & Dev Profiles",
      ],
    },
  },

  // === 03 PLATFORM ===
  {
    id: "section-platform",
    component: "SectionDividerSlide",
    props: { number: "03", title: "PLATFORM" },
  },
  {
    id: "platform-arch",
    component: "ArchitectureSlide",
    props: {
      title: "Platform Architecture",
      subtitle:
        "Full-stack cloud infrastructure powering the development lifecycle",
    },
  },
  {
    id: "software-factory",
    component: "SoftwareFactorySlide",
    props: {},
  },
  {
    id: "authn-authz",
    component: "AuthenticationSlide",
    props: {},
  },
  {
    id: "secure-adb",
    component: "SecureAdbSlide",
    props: {},
  },
  {
    id: "incident-management",
    component: "IncidentManagementSlide",
    props: {},
  },
  {
    id: "cloud-workstations",
    component: "CloudWorkstationsSlide",
    props: {},
  },
  {
    id: "behavioral-parity",
    component: "BehavioralParitySlide",
    props: {},
  },
  {
    id: "host-os",
    component: "HostOSSlide",
    props: {},
  },
  {
    id: "arm-architecture",
    component: "ArmArchitectureSlide",
    props: {},
  },
  {
    id: "compliance-gates",
    component: "ComplianceGatesSlide",
    props: {},
  },
  {
    id: "infra-automation",
    component: "InfraAutomationSlide",
    props: {},
  },
  {
    id: "onboarding-kpis",
    component: "OnboardingKPIsSlide",
    props: {},
  },
  {
    id: "beyond-infotainment",
    component: "BeyondInfotainmentSlide",
    props: {},
  },
  {
    id: "multi-repo",
    component: "MultiRepoSlide",
    props: {},
  },

  // === 04 DISCUSSION ===
  {
    id: "section-discussion",
    component: "SectionDividerSlide",
    props: { number: "04", title: "DISCUSSION" },
  },
  {
    id: "questions-answered",
    component: "QuestionsAnsweredSlide",
    props: {},
  },
  {
    id: "poc-proposal",
    component: "POCProposalSlide",
    props: {},
  },
  {
    id: "appendix",
    component: "ArchitectureSlide",
    props: {
      title: "Appendix — Platform Architecture",
      subtitle: "Complete platform architecture reference diagram",
    },
  },
  {
    id: "thank-you",
    component: "ThankYouSlide",
    props: {},
  },
];
